import { useQueryClient } from "@tanstack/react-query";

import { queryKeyMap } from "@/features/query-client";

import type { ILenderApplicationExtended } from "../types/lender-application";

export const useOptimisticallyUpdateLenderApplication = () => {
  const queryClient = useQueryClient();

  const optimisticallyUpdateLenderApplication = (
    lenderApplicationId: number,
    lenderApplication: ILenderApplicationExtended,
  ) => {
    queryClient.setQueryData(
      queryKeyMap.getLenderApplication(lenderApplicationId),
      lenderApplication,
    );
    queryClient.invalidateQueries({
      queryKey: queryKeyMap.getLenderApplicationsCounts,
    });
  };

  return optimisticallyUpdateLenderApplication;
};
